// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.mjs";
import * as OrderHistoryEntityMapper$PorterinFeature from "../entity-mapper/OrderHistoryEntityMapper.mjs";
import * as ResponseHandler$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ResponseHandler.mjs";
import * as OrderHistoryContentEntityMapper$PorterinFeature from "../entity-mapper/OrderHistoryContentEntityMapper.mjs";

var execute = OrderHistoryEntityMapper$PorterinFeature.execute;

var OrderHistoryConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var OrderHistoryResponseConverter = partial_arg(OrderHistoryConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = OrderHistoryContentEntityMapper$PorterinFeature.execute;

var OrderHistoryContentConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var OrderHistoryContentResponseConverter = partial_arg$1(OrderHistoryContentConverterConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

export {
  OrderHistoryConverterConfig ,
  OrderHistoryResponseConverter ,
  OrderHistoryContentConverterConfig ,
  OrderHistoryContentResponseConverter ,
}
/* OrderHistoryResponseConverter Not a pure module */
